import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { settingsService } from "@/shared/services/settingsService";
import { HTTP_STATUS } from "@/config/constants";
import { logger } from "@/helpers/loggerHelper";
import type { BrandResourceSettingsResponse } from "@/shared/services/settingsService";

interface SettingsState {
  loading: boolean;
  error: unknown;
  brandSettings:
    | BrandResourceSettingsResponse
    | Record<string, never>
    | undefined;
}

interface SettingsRootState {
  settings: SettingsState;
}

const initialState: SettingsState = {
  loading: false,
  error: null,
  brandSettings: {},
};

export const getSettingsThunk = createAsyncThunk<
  BrandResourceSettingsResponse | undefined,
  number | string,
  { rejectValue: unknown }
>("settings/getSettings", async (brandId, { rejectWithValue }) => {
  try {
    const res = await settingsService.checkResourceCenter(brandId);
    if (res.status === HTTP_STATUS.OK && res.data) return res.data;
  } catch (err) {
    logger.error("getSettings error", err);
    return rejectWithValue(err);
  }
});

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSettingsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSettingsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.brandSettings = action.payload;
      })
      .addCase(getSettingsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default settingsSlice.reducer;

// Selector
export const settingSelector = (state: SettingsRootState) => state.settings;
